import { NumberInput, getNumberInputs } from './NumberInput';
import { Operator, getOperators } from './Operator';

/**
 * 入力された式を表す
 * 現状、簡単のために、直接式として文字列を受け取る形にしてるがもし必要であれば、式の構造を表すクラスを作成する
 */
export type InputFormula = string[];

/**
 * InputFormulaにaddValueを加算した結果を返す
 * @param target - 対象となる式
 * @param addValue - 加算する値
 */
export const addInputFormula = (target: InputFormula, addValue: Operator | string | NumberInput): Result<InputFormula, Error> => {
  const returnValue: InputFormula = target.concat(addValue);

  /* OPERATORSでもNUMBER_INPUTSでもないやつ->header はvalidationの都合、1に変換したい */
  const calculateValue = returnValue
    .map((value) => {
      if (!(getOperators().includes(value as Operator) || getNumberInputs().includes(value as NumberInput))) {
        return '1';
      } else {
        return value;
      }
    })
    .join(' ');

  try {
    eval(calculateValue);
    return {
      type: 'success',
      value: returnValue,
    };
  } catch (e) {
    return {
      type: 'error',
      error: new Error('計算として成り立っていません'),
    };
  }
};

/**
 * InputFormulaの末尾を削除した結果を返す
 * @param target - 対象となる式
 */
export const removeInputFormula = (target: InputFormula): Result<InputFormula, Error> => {
  // 末尾を削除する
  const returnValue = target.slice(0, target.length - 1);
  const calculateValue = returnValue.join('');
  try {
    eval(calculateValue);
    return {
      type: 'success',
      value: returnValue,
    };
  } catch (e) {
    return {
      type: 'error',
      error: new Error('計算として成り立っていません'),
    };
  }
};
